import setTableCustomizations from './setTableCustomizations';

export default {
  setTableCustomizations,
};
